import React, { useEffect, useRef, useState } from 'react';
import { Calendar, MapPin, Plane, ArrowRight, ChevronDown } from 'lucide-react';
import Image1 from "../Assets/desktop-1.jpg"
import Image2 from "../Assets/presenting-banner-bg.jpg"
import Image3 from "../Assets/about-banner-web-1.png"
import Image4 from "../Assets/news-media-mention.jpg"
import Mobileim1 from "../Assets/mobile1.png"
import Mobileim2 from "../Assets/mobile1.png"
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../components/BookingContext';


const CarBookingUI = () => {
  const [activeTab, setActiveTab] = useState('roundTrip');
  const [currentBgIndex, setCurrentBgIndex] = useState(0);
  const navigate = useNavigate();
  const { setBookingData } = useBooking();
  const [isMobile, setIsMobile] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);



  useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };
  
  checkMobile();
  window.addEventListener('resize', checkMobile);
  
  return () => window.removeEventListener('resize', checkMobile);
}, []);


 const desktopImages = [Image1, Image2, Image3];
  const mobileImages = [Mobileim1, Mobileim1, Mobileim1]; // Using same mobile image for all slides


    const backgroundImagesArray = isMobile ? mobileImages : desktopImages;

  const [formData, setFormData] = useState({
    fromCity: 'Bangalore',
    toCity: '',
    pickupDate: '',
    returnDate: '',
    package: '4Hr 40Km',
    tripType: 'Pickup From Airport',
    airport: 'Kempegowda International Airport'
  });

  // Trip type options for dropdown
  const tripTypeOptions = [
    'Pickup From Airport',
    'Drop To Airport', 
    'Round Trip',
    // 'One Way',
    // 'Local Trip'
  ];

  // Package options for dropdown
  const packageOptions = [
    // '4Hr 40Km',
    '8Hr 80Km',
    '10Hr 100Km',
    '12Hr 120Km'
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Create an array of background images for auto-sliding
  // const backgroundImagesArray = [
  //   Image1,
  //   Image2,
  //   Image3
  // ];

  const intervalRef = useRef(null);

  // Auto-slide background images every 5 seconds
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentBgIndex((prevIndex) => 
        (prevIndex + 1) % backgroundImagesArray.length
      );
    }, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleBookingStart = () => {
  // Validate required fields based on active tab
  let isValid = true;
  let errorMessage = '';
  
  switch (activeTab) {
    case 'roundTrip':
      if (!formData.toCity || !formData.pickupDate || !formData.returnDate) {
        isValid = false;
        errorMessage = 'Please fill To City, Pickup Date and Return Date';
      }
      break;
    case 'oneWay':
      if (!formData.toCity || !formData.pickupDate) {
        isValid = false;
        errorMessage = 'Please fill To City and Pickup Date';
      }
      break;
    case 'localTrip':
      if (!formData.pickupDate) {
        isValid = false;
        errorMessage = 'Please fill Pickup Date';
      }
      break;
    case 'airportTrip':
      if (!formData.pickupDate) {
        isValid = false;
        errorMessage = 'Please fill Pickup Date';
      }
      break;
  }
  
  if (!isValid) {
    alert(errorMessage);
    return;
  }
  
  // Set booking data in context
  setBookingData(prev => ({
    ...prev,
    tripType: activeTab,
    fromCity: formData.fromCity,
    toCity: formData.toCity,
    pickupDate: formData.pickupDate,
    returnDate: formData.returnDate,
    package: formData.package,
    airport: formData.airport
  }));
  
  // Show terms modal ONLY for round trip after validation passes
  // if (activeTab === 'roundTrip') {
  //   setShowTermsModal(false);
  // } else {
    // Navigate directly for other trip types
    navigate('/vehicle-selection', {
      state: {
        from: formData.fromCity,
        to: formData.toCity,
        pickupDate: formData.pickupDate,
        tripType: activeTab
      }
    });
  // }
};


  const proceedToBooking = () => {
    setBookingData(prev => ({
      ...prev,
      tripType: activeTab,
      fromCity: formData.fromCity,
      toCity: formData.toCity,
      pickupDate: formData.pickupDate,
      returnDate: formData.returnDate,
      package: formData.package,
      airport: formData.airport,
      // acceptedTerms: activeTab === 'roundTrip' ? acceptedTerms : false
    }));
    
    navigate('/vehicle-selection', {
      state: {
        from: formData.fromCity,
        to: formData.toCity,
        pickupDate: formData.pickupDate,
        tripType: activeTab
      }
    });
  };


  const handleAcceptTerms = () => {
    if (acceptedTerms) {
      setShowTermsModal(false);
      proceedToBooking();
    } else {
      alert('Please accept the terms and conditions to proceed.');
    }
  };


  const roundTripTerms = [
    // "Minimum 2 days booking required for round trips",
    "Driver charges: ₹300 per day for overnight stays",
    "Toll charges and parking fees are extra",
    "Night charges (10 PM to 6 AM): 20% extra",
    "Distance calculated from pickup to drop and back to original location",
    "Extra km charge: ₹25/km after package limit",
    "Extra hour charge: ₹250/hour after package limit",
    "Return date/time must be after pickup date/time",
    "Cancellation within 24 hours: 50% charge",
    "No-show: 100% charge"
  ];


  // Function to get current datetime in format for datetime-local input
  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toISOString().slice(0, 16);
  };

  return (
 <div 
      className="w-full min-h-screen bg-cover bg-center bg-no-repeat relative transition-all duration-1000 ease-in-out"
      style={{
        backgroundImage: `url(${backgroundImagesArray[currentBgIndex]})`,
      }}
    >
      <div className="absolute inset-0 bg-black/30 z-0"></div>
      
      <div className="container mx-auto px-4 pt-8 pb-8 max-w-6xl relative z-10">
        <div className="mb-6 md:mb-8">
          <h1 className="text-white text-xl md:text-3xl font-bold mb-2 leading-tight">
            16/12/9 Seater Urbania for Rent in Bangalore
          </h1>
          <p className="text-gray-300 text-sm md:text-base">
            Book your comfortable ride with just a few clicks
          </p>
        </div>
        
        <div className="bg-white rounded-xl md:rounded-2xl shadow-2xl p-3 md:p-4 max-w-4xl mx-auto">
          {/* Updated tab buttons for mobile responsiveness */}
        <div className="grid grid-cols-3 gap-2 mb-4 md:mb-5">
  {[
    { id: 'roundTrip', label: 'Round Trip', icon: 'round', mobileLabel: 'Round Trip' },
    { id: 'localTrip', label: 'Local', icon: 'local', mobileLabel: 'Local' },
    { id: 'airportTrip', label: 'Airport', icon: <Plane className="w-4 h-4 md:w-5 md:h-5" />, mobileLabel: 'Airport' }
  ].map((tab) => (
  <button
  key={tab.id}
  onClick={() => setActiveTab(tab.id)}
  className={`group relative flex items-center justify-center gap-1.5 px-3 py-3 md:py-4 rounded-lg font-bold text-sm transition-all duration-300 whitespace-nowrap overflow-hidden ${
    activeTab === tab.id
      ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg scale-105'
      : 'bg-white text-gray-800 border border-gray-200 hover:bg-gradient-to-r hover:from-blue-50 hover:to-gray-50 hover:border-blue-200 hover:shadow-md hover:scale-105'
  } active:scale-95`}
>
  {/* Subtle shine effect */}
  <div className={`absolute inset-0 transition-transform duration-500 ${
    activeTab === tab.id 
      ? 'translate-x-0' 
      : 'translate-x-[-100%] group-hover:translate-x-[100%]'
  } bg-gradient-to-r from-transparent via-white/20 to-transparent`}></div>
  
  {typeof tab.icon === 'string' ? (
    <svg className={`w-4 h-4 md:w-5 md:h-5 transition-all duration-300 ${
      activeTab === tab.id 
        ? 'scale-125 text-white' 
        : 'group-hover:scale-125 group-hover:text-blue-600'
    }`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
      {/* ... icon paths ... */}
    </svg>
  ) : (
    <div className={`transition-all duration-300 ${
      activeTab === tab.id 
        ? 'scale-125' 
        : 'group-hover:scale-125 group-hover:text-blue-600'
    }`}>
      {tab.icon}
    </div>
  )}
  <span className={`transition-all duration-300 ${
    activeTab === tab.id 
      ? 'font-extrabold tracking-wide' 
      : 'group-hover:font-extrabold'
  }`}>{tab.mobileLabel}</span>
</button>
  ))}
</div>
          
          {activeTab === 'roundTrip' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2 md:gap-3">
              {[
                {
                  icon: <MapPin className="w-3 h-3 md:w-4 md:h-4 text-red-500" />,
                  label: 'From City',
                  value: formData.fromCity,
                  field: 'fromCity',
                  type: 'text',
                  placeholder: null
                },
                {
                  icon: <MapPin className="w-3 h-3 md:w-4 md:h-4 text-blue-500" />,
                  label: 'To City',
                  value: formData.toCity,
                  field: 'toCity',
                  type: 'text',
                  placeholder: 'Enter Drop Location'
                },
                {
                  icon: <Calendar className="w-3 h-3 md:w-4 md:h-4 text-gray-400" />,
                  label: 'Pickup date & time',
                  value: formData.pickupDate,
                  field: 'pickupDate',
                  type: 'datetime-local',
                  placeholder: null,
                  min: getCurrentDateTime()
                },
                {
                  icon: <Calendar className="w-3 h-3 md:w-4 md:h-4 text-gray-400" />,
                  label: 'Return date & time',
                  value: formData.returnDate,
                  field: 'returnDate',
                  type: 'datetime-local',
                  placeholder: 'Select date',
                  min: formData.pickupDate || getCurrentDateTime()
                }
              ].map((field, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                  <div className="flex items-center gap-1 mb-1">
                    {field.icon}
                    <label className="text-gray-500 text-xs">{field.label}</label>
                  </div>
                  <input
                    type={field.type}
                    value={field.value}
                    onChange={(e) => handleInputChange(field.field, e.target.value)}
                    placeholder={field.placeholder}
                    min={field.min}
                    className="w-full text-gray-900 font-medium text-sm outline-none bg-transparent"
                  />
                </div>
              ))}
              
            <button
  onClick={handleBookingStart}
  className="bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold flex items-center justify-center gap-1 md:gap-2 transition-all py-2 md:py-3 text-xs md:text-sm hover:scale-105 active:scale-95 animate-bounce hover:animate-none"
>
  Start Booking
  <ArrowRight className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-2 transition-transform duration-300" />
</button>
            </div>
          )}

          {/* One Way Form */}
          {activeTab === 'oneWay' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
              {[
                {
                  icon: <MapPin className="w-3 h-3 md:w-4 md:h-4 text-red-500" />,
                  label: 'From City',
                  value: formData.fromCity,
                  field: 'fromCity',
                  type: 'text',
                  placeholder: null
                },
                {
                  icon: <MapPin className="w-3 h-3 md:w-4 md:h-4 text-blue-500" />,
                  label: 'To City',
                  value: formData.toCity,
                  field: 'toCity',
                  type: 'text',
                  placeholder: 'Enter Drop Location'
                },
                {
                  icon: <Calendar className="w-3 h-3 md:w-4 md:h-4 text-gray-400" />,
                  label: 'Pickup date & time',
                  value: formData.pickupDate,
                  field: 'pickupDate',
                  type: 'datetime-local',
                  placeholder: null,
                  min: getCurrentDateTime()
                }
              ].map((field, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                  <div className="flex items-center gap-1 mb-1">
                    {field.icon}
                    <label className="text-gray-500 text-xs">{field.label}</label>
                  </div>
                  <input
                    type={field.type}
                    value={field.value}
                    onChange={(e) => handleInputChange(field.field, e.target.value)}
                    placeholder={field.placeholder}
                    min={field.min}
                    className="w-full text-gray-900 font-medium text-sm outline-none bg-transparent"
                  />
                </div>
              ))}
              
              <button
                onClick={handleBookingStart}
                className="bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold flex items-center justify-center gap-1 md:gap-2 transition-all py-2 md:py-3 text-xs md:text-sm"
              >
                Start Booking
                <ArrowRight className="w-3 h-3 md:w-4 md:h-4" />
              </button>
            </div>
          )}

          {/* Local Trip Form - Updated with dropdown for package selection */}
          {activeTab === 'localTrip' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
              {/* From City */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <MapPin className="w-3 h-3 md:w-4 md:h-4 text-red-500" />
                  <label className="text-gray-500 text-xs">From City</label>
                </div>
                <input
                  type="text"
                  value={formData.fromCity}
                  onChange={(e) => handleInputChange('fromCity', e.target.value)}
                  className="w-full text-gray-900 font-medium text-sm outline-none bg-transparent"
                />
              </div>

              {/* Select Package - Changed to dropdown */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <svg className="w-3 h-3 md:w-4 md:h-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                  <label className="text-gray-500 text-xs">Select Package</label>
                </div>
                <div className="relative">
                  <select
                    value={formData.package}
                    onChange={(e) => handleInputChange('package', e.target.value)}
                    className="w-full text-gray-900 font-medium text-sm outline-none bg-transparent appearance-none pr-6"
                  >
                    {packageOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 md:w-4 md:h-4 text-gray-400 pointer-events-none" />
                </div>
              </div>

              {/* Pickup Date & Time */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <Calendar className="w-3 h-3 md:w-4 md:h-4 text-gray-400" />
                  <label className="text-gray-500 text-xs">Pickup date & time</label>
                </div>
                <input
                  type="datetime-local"
                  value={formData.pickupDate}
                  onChange={(e) => handleInputChange('pickupDate', e.target.value)}
                  min={getCurrentDateTime()}
                  className="w-full text-gray-900 font-medium text-sm outline-none bg-transparent"
                />
              </div>
              
              <button 
                onClick={handleBookingStart}
                className="bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold flex items-center justify-center gap-1 md:gap-2 transition-all py-2 md:py-3 text-xs md:text-sm"
              >
                Start Booking
                <ArrowRight className="w-3 h-3 md:w-4 md:h-4" />
              </button>
            </div>
          )}

          {/* Airport Trip Form - Updated with dropdown and datetime picker */}
          {activeTab === 'airportTrip' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2 md:gap-3">
              {/* Trip Type Dropdown */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <Plane className="w-3 h-3 md:w-4 md:h-4 text-gray-700" />
                  <label className="text-gray-500 text-xs">Trip Type</label>
                </div>
                <div className="relative">
                  <select
                    value={formData.tripType}
                    onChange={(e) => handleInputChange('tripType', e.target.value)}
                    className="w-full text-gray-900 font-medium text-xs md:text-sm outline-none bg-transparent appearance-none pr-6"
                  >
                    {tripTypeOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 md:w-4 md:h-4 text-gray-400 pointer-events-none" />
                </div>
              </div>

              {/* Select City */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <MapPin className="w-3 h-3 md:w-4 md:h-4 text-red-500" />
                  <label className="text-gray-500 text-xs">Select City</label>
                </div>
                <input
                  type="text"
                  value={formData.fromCity}
                  onChange={(e) => handleInputChange('fromCity', e.target.value)}
                  className="w-full text-gray-900 font-medium text-xs md:text-sm outline-none bg-transparent"
                />
              </div>

              {/* Select Airport */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <MapPin className="w-3 h-3 md:w-4 md:h-4 text-blue-500" />
                  <label className="text-gray-500 text-xs">Select Airport</label>
                </div>
                <input
                  type="text"
                  value={formData.airport}
                  onChange={(e) => handleInputChange('airport', e.target.value)}
                  className="w-full text-gray-900 font-medium text-xs md:text-sm outline-none bg-transparent"
                />
              </div>

              {/* Pickup Date & Time */}
              <div className="border border-gray-200 rounded-lg p-2 md:p-3 hover:border-blue-300 focus-within:border-blue-500 transition-all">
                <div className="flex items-center gap-1 mb-1">
                  <Calendar className="w-3 h-3 md:w-4 md:h-4 text-gray-400" />
                  <label className="text-gray-500 text-xs">Pickup date & time</label>
                </div>
                <input
                  type="datetime-local"
                  value={formData.pickupDate}
                  onChange={(e) => handleInputChange('pickupDate', e.target.value)}
                  min={getCurrentDateTime()}
                  className="w-full text-gray-900 font-medium text-xs md:text-sm outline-none bg-transparent"
                />
              </div>
              
              <button
                onClick={handleBookingStart}
                className="bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold flex items-center justify-center gap-1 md:gap-2 transition-all py-2 md:py-3 text-xs md:text-sm"
              >
                Start Booking
                <ArrowRight className="w-3 h-3 md:w-4 md:h-4" />
              </button>
            </div>
          )}
        </div>

        {/* Background image indicators */}
        <div className="mt-4 flex justify-center gap-2">
          {backgroundImagesArray.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setCurrentBgIndex(index);
                if (intervalRef.current) {
                  clearInterval(intervalRef.current);
                  intervalRef.current = setInterval(() => {
                    setCurrentBgIndex((prevIndex) => 
                      (prevIndex + 1) % backgroundImagesArray.length
                    );
                  }, 5000);
                }
              }}
              className={`w-2 h-2 rounded-full transition-all ${
                currentBgIndex === index 
                  ? 'bg-white w-4' 
                  : 'bg-white/50 hover:bg-white/80'
              }`}
              aria-label={`Go to background ${index + 1}`}
            />
          ))}
        </div>

        


        {/* <div className="mt-6 md:mt-8 text-center">
          <div cl
          assName="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span className="text-white text-sm">Available 24/7 • Free Cancellation • Safe & Secure</span>
          </div>
        </div> */}


        {showTermsModal && (
  <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-3 sm:p-4">
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl w-full max-w-sm sm:max-w-md md:max-w-lg max-h-[85vh] overflow-hidden">
      {/* Modal Header */}
      <div className="flex items-start justify-between p-4 sm:p-5 border-b">
        <div className="pr-4">
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 leading-tight">
            Round Trip Terms & Conditions
          </h2>
          <p className="text-xs text-gray-500 mt-1">
            Please read and accept the terms
          </p>
        </div>
        <button
          onClick={() => {
            setShowTermsModal(false);
            setAcceptedTerms(false); // Reset checkbox when closing
          }}
          className="p-1.5 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body */}
      <div className="p-4 sm:p-5 overflow-y-auto max-h-[50vh]">
        {/* Trip Details */}
        {/* <div className="mb-4">
          <h3 className="text-sm font-semibold text-gray-700 mb-2">
            Trip Details
          </h3>
          <div className="grid grid-cols-2 gap-2 mb-4">
            <div className="bg-blue-50 p-2.5 rounded-lg">
              <p className="text-xs text-gray-500">From</p>
              <p className="font-semibold text-sm truncate">{formData.fromCity}</p>
            </div>
            <div className="bg-blue-50 p-2.5 rounded-lg">
              <p className="text-xs text-gray-500">To</p>
              <p className="font-semibold text-sm truncate">{formData.toCity || 'Not specified'}</p>
            </div>
            <div className="bg-blue-50 p-2.5 rounded-lg">
              <p className="text-xs text-gray-500">Pickup</p>
              <p className="font-semibold text-xs truncate">
                {formData.pickupDate 
                  ? new Date(formData.pickupDate).toLocaleString('en-IN', {
                      day: 'numeric',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : 'Not specified'}
              </p>
            </div>
            <div className="bg-blue-50 p-2.5 rounded-lg">
              <p className="text-xs text-gray-500">Return</p>
              <p className="font-semibold text-xs truncate">
                {formData.returnDate 
                  ? new Date(formData.returnDate).toLocaleString('en-IN', {
                      day: 'numeric',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : 'Not specified'}
              </p>
            </div>
          </div>
        </div> */}

        {/* Important Terms */}
        <div className="mb-5">
          <h3 className="text-sm font-semibold text-gray-700 mb-2">
            Important Terms
          </h3>
          <ul className="space-y-2.5">
            {roundTripTerms.map((term, index) => (
              <li key={index} className="flex items-start gap-2">
                <div className="bg-blue-100 text-blue-600 rounded-full p-0.5 mt-0.5 flex-shrink-0">
                  <svg className="w-2.5 h-2.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-xs text-gray-700 leading-relaxed">{term}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Warning Note */}
        {/* <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-5">
          <div className="flex items-start gap-2.5">
            <div className="bg-yellow-100 text-yellow-600 rounded-full p-1 flex-shrink-0">
              <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <h4 className="font-semibold text-yellow-800 text-sm">Important Note</h4>
              <p className="text-yellow-700 text-xs mt-0.5 leading-relaxed">
                Please ensure all details are correct before proceeding. Any changes after booking may incur additional charges.
              </p>
            </div>
          </div>
        </div> */}

        {/* Acceptance Checkbox */}
        <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
          <input
            type="checkbox"
            id="acceptTerms"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
            className="mt-0.5 w-4 h-4 text-blue-600 rounded focus:ring-blue-500 flex-shrink-0"
          />
          <label htmlFor="acceptTerms" className="text-xs text-gray-700 leading-relaxed">
            <span className="font-semibold">I have read and accept</span> all the terms and conditions mentioned above. I understand that any violation may result in additional charges.
          </label>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="flex justify-between items-center p-4 border-t bg-gray-50">
        <button
          onClick={() => {
            setShowTermsModal(false);
            setAcceptedTerms(false);
          }}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium"
        >
          Cancel
        </button>
        <button
          onClick={handleAcceptTerms}
          disabled={!acceptedTerms}
          className={`px-5 py-2 rounded-lg font-semibold text-sm flex items-center gap-1.5 transition-colors ${
            acceptedTerms
              ? 'bg-blue-600 text-white hover:bg-blue-700'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          Proceed
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default CarBookingUI;